import React, { useEffect, useState } from 'react'

import { useAxios } from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'
import Modal2 from "../../../components/modal2026/Modal";
import ModalVideo from "../../../components/modal2026/ModalVideoSobre";
import YoutubeLite from "../../../components/YoutubeLite/YoutubeLite";

const Ideas = () => {

    const [t, i18n] = useTranslation("home");
    const [t2] = useTranslation("sobre_mi");
    const liga_lang = '/' + i18n.language + "/Ideas-en-Corto";

    const { data, isloading } = useAxios(
        `https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/gnideas?offset=0&next=10&lang=${i18n.language}`
    );

    const [ideas, setIdeas] = useState(null);

    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [id_liga, setId_liga] = useState("");
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [textVideo, settextVideo] = useState("");
    const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
    const [urlVideo, setUrlVideo] = useState("");

    const openModal2 = (value1, value2, value4) => {
        setVariable1(value1);
        setVariable2(value2);
        setId_liga(value4);
        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setVariable1("");
        setVariable2("");
        setIsModalOpen2(false);
    };

    const openModalVideo = (contenido, id) => {
        setUrlVideo(contenido);
        setIsOpenModalVideo(true);
        settextVideo(id);
    };

    const closeModalVideo = () => {
        setUrlVideo("");
        setIsOpenModalVideo(false);
        settextVideo("");
    };

    const renderizarMensaje = (tipo, contenido, preview, id) => {
        if (tipo === "youtube") {
            openModalVideo(contenido, id);
        } else if (tipo === "video") {
            openModal2("https://www.ricardosalinas.com" + contenido, "video", id);
        } else if (tipo === "texto-video") {
            openModal2(contenido, "", id);
        }
    };

    const ideasFiltradas = ideas
        ?.filter(item =>
            item.tipo === "texto-video" ||
            item.tipo === "video" ||
            item.tipo === "youtube"
        )
        .slice(0, 4);

    useEffect(() => {
        if (data) {
            setIdeas(data);
        }
    }, [data]);

    if (isloading || ideas === null) {
        return <div className="home_dos">Is Loading...</div>;
    }


    return (
        <div>
            <div className="_ngcontent-ng-c3910305518">
                <section aria-labelledby="about-curious-facts-title"
                    class="about-curious-facts">
                    <div class="about-curious-facts__content">
                        <h2 id="about-curious-facts-title" class="about-curious-facts__title">
                            {t("2026.curiosos")}</h2>
                    </div>
                    <div class="about-curious-facts__rail">
                        <div aria-label="Videos de datos curiosos"
                            class="about-curious-facts__grid">
                            {/* 
                            {ideasFiltradas.map((item, index) => (
                                <article
                                    key={index}
                                    className="about-curious-facts__card"
                                    onClick={() =>
                                        renderizarMensaje(
                                            item.tipo,
                                            item.contenido,
                                            item.preview,
                                            item.id
                                        )
                                    }
                                >
                                    <img
                                        loading="lazy"
                                        className="about-curious-facts__card-image"
                                        src={'https://www.ricardosalinas.com' + item.preview}
                                        alt={item.titulo}
                                    />

                                    <button
                                        type="button"
                                        className="about-curious-facts__card-play"
                                        aria-label={`Reproducir ${item.titulo}`}
                                    >
                                        <img
                                            src="/assets/img2026/video_player_button.svg"
                                            alt="Reproducir"
                                            aria-hidden="true"
                                        />
                                    </button>

                                    <div className="about-curious-facts__card-copy">
                                        <h3>{item.titulo}</h3>
                                    </div>
                                </article>
                            ))}*/}
                            <article
                                className="about-curious-facts__card"
                                onClick={() => openModalVideo("https://www.youtube.com/embed/UgJ02kn8Nwo", t2("anecdotas.idea_1"))}
                            >
                                <img
                                    loading="lazy"
                                    className="about-curious-facts__card-image"
                                    src="/assets/img2026/Post-1.png"
                                    alt="prueba"
                                />

                                <button
                                    type="button"
                                    className="about-curious-facts__card-play"
                                    aria-label={`Reproducir ${t2("anecdotas.idea_1")}`}
                                >
                                    <img
                                        src="/assets/img2026/video_player_button.svg"
                                        alt="Reproducir"
                                        aria-hidden="true"
                                    />
                                </button>

                                <div className="about-curious-facts__card-copy">
                                    <h3>{t2("anecdotas.idea_1")}</h3>
                                    <p className="reflexion-video-card__duration">
                                        0:32 min
                                    </p>
                                </div>
                            </article>

                            <article
                                className="about-curious-facts__card"
                                onClick={() => openModalVideo("https://www.youtube.com/embed/1L9TrMGOJ30", t2("anecdotas.idea_2"))}
                            >
                                <img
                                    loading="lazy"
                                    className="about-curious-facts__card-image"
                                    src="/assets/img2026/Post-2.png"
                                    alt="prueba"
                                />

                                <button
                                    type="button"
                                    className="about-curious-facts__card-play"
                                    aria-label={`Reproducir ${t2("anecdotas.idea_2")}`}
                                >
                                    <img
                                        src="/assets/img2026/video_player_button.svg"
                                        alt="Reproducir"
                                        aria-hidden="true"
                                    />
                                </button>

                                <div className="about-curious-facts__card-copy">
                                    <h3>{t2("anecdotas.idea_2")}</h3>
                                    <p className="reflexion-video-card__duration">
                                        0:30 min
                                    </p>
                                </div>
                            </article>

                            <article
                                className="about-curious-facts__card"
                                onClick={() => openModalVideo("https://www.youtube.com/embed/cAbNd-6knFQ", t2("anecdotas.idea_3"))}
                            >
                                <img
                                    loading="lazy"
                                    className="about-curious-facts__card-image"
                                    src="/assets/img2026/Post-3.png"
                                    alt="prueba"
                                />

                                <button
                                    type="button"
                                    className="about-curious-facts__card-play"
                                    aria-label={`Reproducir ${t2("anecdotas.idea_3")}`}
                                >
                                    <img
                                        src="/assets/img2026/video_player_button.svg"
                                        alt="Reproducir video"
                                        aria-hidden="true"
                                    />
                                </button>

                                <div className="about-curious-facts__card-copy">
                                    <h3>{t2("anecdotas.idea_3")}</h3>
                                    <p className="reflexion-video-card__duration">
                                        0:21 min
                                    </p>
                                </div>
                            </article>

                            <article
                                className="about-curious-facts__card"
                                onClick={() => openModalVideo("https://www.youtube.com/embed/Cgg054PSeuQ", t2("anecdotas.idea_4"))}
                            >
                                <img
                                    loading="lazy"
                                    className="about-curious-facts__card-image"
                                    src="/assets/img2026/Post-4.png"
                                    alt="prueba"
                                />

                                <button
                                    type="button"
                                    className="about-curious-facts__card-play"
                                    aria-label={`Reproducir ${t2("anecdotas.idea_4")}`}
                                >
                                    <img
                                        src="/assets/img2026/video_player_button.svg"
                                        alt="Reproducir video"
                                        aria-hidden="true"
                                    />
                                </button>

                                <div className="about-curious-facts__card-copy">
                                    <h3>{t2("anecdotas.idea_4")}</h3>
                                    <p className="reflexion-video-card__duration">
                                        0:25 min
                                    </p>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>
            </div>

            <Modal2
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                id_idea={id_liga}
                variable1={variable1}
                variable2={variable2}
            />

            <ModalVideo
                isOpen={isOpenModalVideo}
                closeModal={closeModalVideo}
                urlVideo={urlVideo}
                titulo={textVideo}
            />
        </div>
    );
};

export default Ideas;